/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useState, useCallback } from 'react';
import StopPropagationWrapper from 'AdsUI/components/StopPropagationWrapper';
import Immutable from 'immutable';
import FormattedNumber from 'I18n/components/FormattedNumber';
import UILink from 'UIComponents/link/UILink';
import { ContactListFunnelStage, AttributionViews, NETWORKS_WITH_ALL } from 'AdsUI/lib/Constants';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import GlobalFiltersRecord from 'AdsUI/records/reporting/GlobalFiltersRecord';
import makeLoadable from 'AdsUI/lib/makeLoadable';
const ContactListDropModalContainerLoader = makeLoadable(() => import('AdsUI/components/ContactListDropModalContainer'));

const NullComponent = ({
  children
}) => children;

const handleStopPropagation = e => e.stopPropagation();

const ContactListDropContainer = ({
  value,
  funnelStage,
  attributionView,
  globalFilters,
  network,
  entity,
  entityType,
  overrideAdAccounts
}) => {
  const [dropModalOpen, setDropModalOpen] = useState(false);
  const onOpenModal = useCallback(() => {
    usageTracker.track('viewedContactList', {
      action: 'Viewed contact list'
    });
    setDropModalOpen(true);
  }, [setDropModalOpen]);
  const Wrapper = value > 0 ? UILink : NullComponent;
  return /*#__PURE__*/_jsxs(StopPropagationWrapper, {
    children: [/*#__PURE__*/_jsx(Wrapper, {
      onClick: onOpenModal,
      children: /*#__PURE__*/_jsx(FormattedNumber, {
        value: value
      })
    }), dropModalOpen && /*#__PURE__*/_jsx("div", {
      onMouseMove: handleStopPropagation,
      children: /*#__PURE__*/_jsx(ContactListDropModalContainerLoader, {
        value: value,
        funnelStage: funnelStage,
        attributionView: attributionView,
        globalFilters: globalFilters,
        network: network,
        entity: entity,
        entityType: entityType,
        overrideAdAccounts: overrideAdAccounts,
        closeModal: () => setDropModalOpen(false)
      })
    })]
  });
};

ContactListDropContainer.propTypes = {
  entity: PropTypes.object,
  funnelStage: PropTypes.oneOf(Object.keys(ContactListFunnelStage)),
  network: PropTypes.oneOf(NETWORKS_WITH_ALL),
  value: PropTypes.number,
  attributionView: PropTypes.oneOf(Object.keys(AttributionViews)),
  globalFilters: PropTypes.instanceOf(GlobalFiltersRecord).isRequired,
  overrideAdAccounts: PropTypes.instanceOf(Immutable.List)
};
export default ContactListDropContainer;